

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);


    const { setLoading, successToast, errorToast } = useGlobalFunc()
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);

    const [data, setData] = useState(null)

    async function getData(id) {
        setLoading(true)
        try {
            let res = await UserApi.negotiationGet({ id: id })
            console.log(res.data.data)
            setData(res.data.data)


        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)

    }

    useEffect(() => {
        let id = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
        console.log(id)
        getData(id)
    }, []);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="text-lg font-bold mb-4">協談申請單明細</div>
        {
            data &&
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
                <div className="sm:col-span-2">
                    <p className=" text-sm font-bold mb-2">被協談者姓名</p>
                    <div className="input w-full" >
                        {data.name}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">聯絡電話</p>
                    <div className="input w-full" >
                        {data.phone}
                    </div>
                </div>

                <div>
                    <p className="text-sm font-bold mb-2">LINE ID</p>
                    <div className="input w-full" >
                        {data.lineId}
                    </div>
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">地區</p>
                    <div className="input w-full" >
                        {data.region}
                    </div>
                </div>
                <div className="">
                    <p className="text-sm font-bold mb-2">地址</p>
                    <div className="input w-full" >
                        {data.address}
                    </div>
                </div>
                <div className="sm:col-span-2">
                    <p className="text-sm font-bold mb-2">協談項目</p>
                    <div className="input w-full" >
                        {data.type}
                    </div>
                </div>
                <div className="sm:col-span-2">
                    <p className="text-sm font-bold mb-2">說明欄</p>
                    <div className="input w-full" >
                        {data.description}
                    </div>
                </div>

                <div className="sm:col-span-2 w-full  h-px bg-black06">
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">協談進度</p>
                    <div className="input w-full" >
                        {t(`negotationStatus.${data.status}`)}
                    </div>
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">被派送協談者</p>
                    <div className="input w-full" >
                        {data.negotiator && data.negotiator.name}
                    </div>
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">聯絡電話</p>
                    <div className="input w-full" >
                        {data.negotiator && data.negotiator.phone}
                    </div>
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">LINE ID</p>
                    <div className="input w-full" >
                        {data.negotiator && data.negotiator.lineId}
                    </div>
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">派送日期</p>
                    <div className="input w-full" >
                        {data.dispatchDate}
                    </div>
                </div>

                <div className="">
                    <p className="text-sm font-bold mb-2">協談完成日期</p>
                    <div className="input w-full" >
                        {data.endDate}
                    </div>
                </div>

                <div className="sm:col-span-2 w-full  h-px bg-black06">
                </div>


                <div className="sm:col-span-2">
                    <p className="text-sm font-bold mb-2">管理員回覆</p>
                    <div className="input w-full" >
                        {data.comments}
                    </div>
                </div>

                <div className="flex justify-start mt-4">
                    <button onClick={() => navigate('/membercenter/negotiation')} className="btn1 !min-w-[120px]">
                        返回
                    </button>
                </div>

            </div>
        }
    </div>

}

export default Home